/**
 * Divider Component
 * 
 * Simple horizontal divider for separating content sections.
 * Based on FAQ page border styling.
 */

interface DividerProps {
  className?: string;
  spacing?: 'tight' | 'normal' | 'loose';
}

export default function Divider({ className = '', spacing = 'normal' }: DividerProps) {
  const spacingStyles = {
    tight: 'my-6',
    normal: 'my-8', 
    loose: 'my-12',
  }[spacing];

  return (
    <hr className={`border-oro-border ${spacingStyles} ${className}`} />
  );
}